import React from "react";
import AdminSessions from "../../components/AdminSessions/AdminSessions";
import Footer from "../../common/Footer/Footer";
import UserPage from "../../common/UserPage/UserPage";

const AdminSessionsPage = () => {
  return (
    <div>
      <UserPage />
      <AdminSessions />
      <Footer />
    </div>
  );
};

export default AdminSessionsPage;
